<script>
import api from '@/helpers/api'

export default {
  props: {
    addressId: {
      required: true,
      type: String
    },
    customerId: {
      required: true,
      type: String
    }
  },

  data: () => ({
    isLoading: false,
    address: {}
  }),

  watch: {
    addressId: {
      handler: 'load',
      immediate: true
    }
  },

  methods: {
    async load () {
      this.isLoading = true
      let item = await api.customerAddresses.fetch({
        customer_id: this.customerId,
        address_id: this.addressId
      })

      const { alias, is_active, address } = item
      this.isLoading = false
      this.address = {
        alias,
        is_active,
        ...address
      }
    }
  },

  mounted () {
    this.load()
  },

  render () {
    return this.$scopedSlots.default({
      address: this.address,
      isLoading: this.isLoading
    })
  }
}
</script>
